import { Download, ExternalLink } from "lucide-react";
import { toast } from "sonner";
import { adminApi, downloadFile, formatApiError } from "@/lib/adminApi";
import { money } from "@/studio/ui";

export const BASE = process.env.REACT_APP_BACKEND_URL;
export const cents = (c) => money((c || 0) / 100);
export const err = (e) => toast.error(formatApiError(e.response?.data?.detail));
export const abs = (u) => (u?.startsWith("/api") ? `${BASE}${u}` : u);
export const today = () => new Date().toISOString().slice(0, 10);

export const run = async (promise, ok, after) => {
  try {
    const r = await promise;
    if (ok) toast.success(typeof ok === "function" ? ok(r) : ok);
    if (after) after(r);
    return r;
  } catch (e) { err(e); return null; }
};

export const openDoc = (url, name) => {
  if (!url) return;
  if (url.startsWith("/api/studio-files") || url.startsWith("http")) { window.open(abs(url), "_blank", "noopener"); return; }
  downloadFile(url.replace(/^\/api/, ""), name || "document").catch(() => toast.error("Download failed"));
};

export const DocButton = ({ url, name, label, testId, icon = "download" }) => (
  <button className="st-btn st-btn--ghost st-btn--sm" onClick={() => openDoc(url, name)} data-testid={testId}>
    {icon === "open" ? <ExternalLink size={13} /> : <Download size={13} />} {label}
  </button>
);

export const upload = (path, fields) => {
  const fd = new FormData();
  Object.entries(fields).forEach(([k, v]) => {
    if (v == null || v === "") return;
    if (Array.isArray(v)) v.forEach((x) => fd.append(k, x)); else fd.append(k, v);
  });
  return adminApi.post(path, fd);
};

export const Field = ({ label, children, wide }) => (
  <label className={`st-field ${wide ? "st-field--wide" : ""}`}><span className="st-label">{label}</span>{children}</label>
);

export const Tag = ({ tone, children, testId }) => <span className={`st-tag ${tone ? `st-tag--${tone}` : ""}`} data-testid={testId}>{children}</span>;

export const BOARD_TONE = { draft: "unk", sent: "warn", changes_requested: "warn", not_my_style: "warn", approved: "ok" };
